import React from 'react';
import { MemberFieldSchemasQuery_schemas } from '@frontend/app/queries/types/MemberFieldSchemasQuery';
import { getLabelForFieldType } from '@frontend/app/containers/Communities/AddOrEditCommunity/CommunityIdentity/utils';
import { isEmpty } from 'lodash';
import { CustomFieldType } from '@frontend/app/types/globalTypes';
import { IField } from '../../../LandingPages/types';

export const ADDRESS_FIELD_NAMES = [
  'Address First Name',
  'Address Last Name',
  'Address1',
  'Address2',
  'City',
  'State',
  'PostalCode',
  'Country',
];

/**
 * Helper function to truncate text to 35 characters with ellipsis if longer
 * @param text - The text to truncate
 * @returns Truncated text with ellipsis if needed
 */
const truncateLongLabelFields = (text: string): string => {
  if (text.length <= 35) return text;
  return `${text.substring(0, 35)}...`;
};

export const convertFieldsToSelectItems = (schemas: MemberFieldSchemasQuery_schemas[], usedFields: IField[]) => {
  const schemasWithAddressParent: MemberFieldSchemasQuery_schemas[] = [
    {
      id: -123456789,
      name: 'Address',
      __typename: 'MemberFieldSchema' as const,
      type: CustomFieldType.TEXT,
      applicationId: '',
      isDefault: false,
      choices: [],
      metaData: undefined
    },
    ...schemas,
  ].sort((a, b) => a.name.localeCompare(b.name));

  const usedAddressFields = usedFields.filter((field) => ADDRESS_FIELD_NAMES.includes(field.name));
  const addressFieldsParent = {
    value: '-123456789',
    label: 'Address',
    disabled: usedAddressFields.length === ADDRESS_FIELD_NAMES.length,
    children: ADDRESS_FIELD_NAMES.map((field) => {
      const schema = schemas.find((schema) => schema.name === field);
      if (!schema) {
        return null;
      }
      return {
        value: schema.id.toString(),
        label: (
          <div className="flex items-center gap-2">
            <span title={schema.name}>{truncateLongLabelFields(schema.name)}</span>
            <span className="text-xs text-grey-4 ml-1">
              {getLabelForFieldType(schema.type, !isEmpty(schema.choices))}
            </span>
          </div>
        ),
        disabled: usedAddressFields.some((usedField) => usedField.id === schema.id),
      };
    }).filter(Boolean),
  };

  const nonAddressFields = schemasWithAddressParent.filter((schema) => !ADDRESS_FIELD_NAMES.includes(schema.name));

  return nonAddressFields.map((schema) => {
    if (schema.name === 'Address') {
      return addressFieldsParent;
    }

    return {
      value: schema.id.toString(),
      label: (
        <div className="flex items-center gap-2">
          <span title={schema.name}>{truncateLongLabelFields(schema.name)}</span>
          <span className="text-xs text-grey-4 ml-1">
            {getLabelForFieldType(schema.type, !isEmpty(schema.choices))}
          </span>
        </div>
      ),
      disabled: usedFields.some((usedField) => usedField.id === schema.id),
    };
  });
};
